// no 0/O, 1/l/I: a generated password is often read out or typed from a message
const PASSWORD_ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789";
const GENERATED_PASSWORD_LENGTH = 8;

// the users service has the final word; these only save a round trip for the obvious cases
export const PASSWORD_MIN_LENGTH = 5;
export const PASSWORD_MAX_BYTES = 72;

// crypto.getRandomValues, not Math.random; rejection sampling keeps every character equally likely
export const randomPassword = () => {
  const limit = 256 - (256 % PASSWORD_ALPHABET.length);
  let password = "";
  while (password.length < GENERATED_PASSWORD_LENGTH) {
    const [byte] = window.crypto.getRandomValues(new Uint8Array(1));
    if (byte < limit) password += PASSWORD_ALPHABET[byte % PASSWORD_ALPHABET.length];
  }

  return password;
};

/** Element UI rules for a password field. */
export const passwordRules = () => [
  { required: true, message: "Enter a password", trigger: "blur" },
  { min: PASSWORD_MIN_LENGTH, message: `At least ${PASSWORD_MIN_LENGTH} characters`, trigger: "blur" },
  {
    // bcrypt ignores everything after 72 bytes, so a longer one would only look stronger
    validator: (rule, value, callback) =>
      new TextEncoder().encode(value || "").length <= PASSWORD_MAX_BYTES
        ? callback()
        : callback(new Error(`At most ${PASSWORD_MAX_BYTES} bytes`)),
    trigger: "blur",
  },
];
